import React from 'react';
import config from '../../../config';
import styles from './inquire-cta.module.scss';
import { InquireCtaProps } from '../types';

// Desktop Main Menu Inquire CTA (hidden in Trips app)
// Mobile Open Menu Inquire CTA

const InquireCTA = ({
  isTravelCompany,
  onClick,
}: InquireCtaProps) => (isTravelCompany ? (
  <div
    className={styles['inquire-disabled']}
    aria-disabled="true"
  >
    Design My Dream Trip
    <p className={styles['inquire-disabled-tooltip']}>
      Only travelers can submit trip requests
    </p>
  </div>
) : (
  <>
    <a
      className={`${styles.inquire} ${styles['inquire-desktop']}`}
      href={`${config.Z3_URL.replace(/\/$/, '')}/trip-request`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      Design My Dream Trip
    </a>
    <a
      className={`${styles.inquire} ${styles['inquire-mobile']}`}
      href={`${config.Z3_URL.replace(/\/$/, '')}/trip-request`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      Design My Dream Trip
    </a>
  </>
)
);

export default InquireCTA;
